'use client';

import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { BookOpen, Zap, Shield } from 'lucide-react';
import Link from 'next/link';

export default function HomepageHero() {
  const { currentUser, isAdmin } = useAuth();
  const name = currentUser?.name || 'there';

  return (
    <section className="relative">
      {/* Subtle gold glow */}
      <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-96 h-48 rounded-full opacity-5 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, #C9A84C 0%, transparent 70%)' }}
      />

      <div className="relative text-center max-w-3xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-surface text-xs text-muted-foreground mb-6">
          <Zap className="w-3.5 h-3.5 text-gold" />
          <span>Hi, {isAdmin ? 'Admin' : name}! Welcome back to your knowledge hub.</span>
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl xl:text-6xl font-semibold text-foreground leading-tight mb-4">
          SilkCards Internal
          <br />
          <span className="text-gold">Knowledge Base</span>
        </h1>

        <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-8">
          Your centralized hub for SOPs, product knowledge, and support workflows.
          Find any answer within 3 clicks during live customer interactions.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <BookOpen className="w-4 h-4 text-gold" />
            <span>Articles across all sections</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-border" />
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block" />
            <span>Last updated Sep 6, 2026</span>
          </div>
          {isAdmin && (
            <>
              <div className="w-1 h-1 rounded-full bg-border" />
              <Link href="/admin" className="flex items-center gap-1.5 text-gold hover:text-gold-light transition-colors">
                <Shield className="w-3.5 h-3.5" />
                Admin Dashboard
              </Link>
            </>
          )}
        </div>
      </div>

      <div className="gold-divider mt-12" />
    </section>
  );
}